export const SimulationChartType = Object.freeze({
  TOTAL_DAYS: 'total_days',
  METERS_PER_DAY: 'meters_per_day',
  CUMULATIVE_PROBABILITY: 'cumulative-probability',
});

export const CampaignTabIndex = Object.freeze({
  Input: 0,
  Operations: 1,
  Result: 2,
  TimeTracker: 3,
});

export const CampaignStatus = Object.freeze({
  Prototype: 'Prototype',
  Actual: 'Actual',
});
